export const API_EMPLOYEE_USER = "/api/User";
export const API_EMPLOYEE_USER_SEARCH = "/api/User/Search";

export const API_ADMIN_USER = "/api/User/AdminUser";
export const API_ADMIN_USER_ADD = "/api/admin/User/AddUser";
export const API_UPDATE_PROFILE = "/api/User/UpdateUserProfile";
// export const API_ADMIN_USER_SEARCH = "/api/User/AdminUser/Search";

export const API_SUBSCRIPTON_USER =
  "/api/admin/UsersSubscription/SearchById?userId=";
export const API_SUBSCRIPTON_USER_ADD =
  "/api/admin/UsersSubscription/AssignUser";
export const API_SUBSCRIPTON_USER_SEARCH =
  "/api/admin/UsersSubscription/Search";

export const API_ALL_SUBSCRIPTION_TYPES =
  "/api/admin/Lookup/SubscriptionsTypes";

export const API_ALL_USERS = "/api/admin/Lookup/Users";
export const API_ALL_END_USERS = "/api/admin/Lookup/EndUsers";
export const API_END_USER = "/api/User/EndUser";
export const API_UPDATE_END_USER = "/api/User/UpdateEndUser";
export const UNLOCKED_USER = "/api/User/UnlockedUser?id=";
export const ACTIVE_USER = "/api/User/ActiveUser?id=";
export const BAN_USER = "/api/User/BanUser?id=";

export const API_ADD_JOB_CATEGORY = "/api/admin/journalCategory";
export const API_JOURNAL_CATEGORY_SEARCH = "/api/admin/JournalCategory/Search";
export const API_JOURNAL_CATEGORY = "/api/admin/JournalCategory";
export const API_JOURNAL_NEWS = "/api/admin/Journalism";
export const API_JOURNAL_NEWS_SEARCH = "/api/admin/Journalism/Search";
export const API_JOURNAL_NEWS_TRASH = "/api/admin/Journalism/Trash";
export const API_JOURNAL_NEWS_UN_TRASH = "/api/admin/Journalism/UnTrash";

export const API_JOURNAL_NEWS_STATISTICS =
  "/api/admin/Journalism/GetStatistics";
export const API_FILE_UPLOAD = "/api/admin/PhotoUploader";
export const API_NEWS_CATEGORY = "/api/admin/NewsCategory";
export const API_CATEGORY = "/api/admin/Category";
export const API_CATEGORY_STATISTICS = "/api/admin/Category/GetStatistics";
export const API_CATEGORY_SEARCH = "/api/admin/Category/Search";
export const API_NEWS = "/api/admin/News";
export const API_NEWS_SEARCH = "/api/admin/News/Search";
export const API_NEWS_STATISTICS = "/api/admin/News/GetStatistics";
export const API_NEWS_TRASH = "/api/admin/News/Trash";
export const API_NEWS_UN_TRASH = "/api/admin/News/UnTrash";

export const API_GOVERNORATES = "/api/admin/Governorate";
export const API_REGIONAL_OFFICE = "/api/admin/RegionalOffice";
export const API_REGIONAL_OFFICE_SEARCH = "/api/admin/RegionalOffice/Search";
export const API_REGIONAL_OFFICE_STATISTICS =
  "/api/admin/RegionalOffice/GetStatistics";
export const API_REGIONAL_OFFICE_TRASH = "/api/admin/RegionalOffice/Trash";
export const API_REGIONAL_OFFICE_UN_TRASH = "/api/admin/RegionalOffice/UnTrash";
export const API_ADDITIONAL_OFFICE = "/api/admin/AdditionalOffice";

export const API_VIDEO_LIBRARY_CATEGORY = "/api/admin/VideoLibraryCategory";
export const API_VIDEO_LIBRARY_CATEGORY_SEARCH =
  "/api/admin/VideoLibraryCategory/Search";
export const API_VIDEO_LIBRARY_CATEGORY_TRASH =
  "/api/admin/VideoLibraryCategory/Trash";
export const API_VIDEO_LIBRARY_CATEGORY_UN_TRASH =
  "/api/admin/VideoLibraryCategory/UnTrash";

export const API_VIDEO_LIBRARY = "/api/admin/VideoLibrary";
export const API_VIDEO_LIBRARY_SEARCH = "/api/admin/VideoLibrary/Search";
export const API_VIDEO_LIBRARY_STATISTICS =
  "/api/admin/VideoLibrary/GetStatistics";
export const API_VIDEO_LIBRARY_TRASH = "/api/admin/VideoLibrary/Trash";
export const API_VIDEO_LIBRARY_UN_TRASH = "/api/admin/VideoLibrary/UnTrash";

export const API_PHOTO_MEDIA_CATEGORY = "/api/admin/PhotoCategory";
export const API_PHOTO_MEDIA_CATEGORY_SEARCH =
  "/api/admin/PhotoCategory/Search";
export const API_PHOTO_MEDIA_CATEGORY_STATISTICS =
  "/api/admin/PhotoCategory/GetStatistics";
export const API_PHOTO_MEDIA_CATEGORY_TRASH = "/api/admin/PhotoCategory/Trash";
export const API_PHOTO_MEDIA_CATEGORY_UN_TRASH =
  "/api/admin/PhotoCategory/UnTrash";

export const API_PHOTO_MEDIA = "/api/admin/PhotoAlbum";
export const API_PHOTO_MEDIA_SEARCH = "/api/admin/PhotoAlbum/Search";
export const API_PHOTO_MEDIA_STATISTICS = "/api/admin/PhotoAlbum/GetStatistics";
export const API_PHOTO_MEDIA_TRASH = "/api/admin/PhotoAlbum/Trash";
export const API_PHOTO_MEDIA_UN_TRASH = "/api/admin/PhotoAlbum/UnTrash";

export const API_PHOTO_ALBUM = "/api/admin/Photo";
export const API_PHOTO_ALBUM_PIN_UPDATE = "/api/admin/Photo/PinUpdate";
export const API_PHOTO_ALBUM_DELETE = "/api/admin/Photo/DeleteBatch";
export const API_EVENT_TYPE = "/api/admin/EventType";
export const API_EVENT_TYPE_SEARCH = "/api/admin/EventType/Search";
export const API_EVENT_TYPE_STATISTICS = "/api/admin/EventType/GetStatistics";

export const API_EVENT = "/api/admin/Event";
export const API_EVENT_SEARCH = "/api/admin/Event/Search";
export const API_EVENT_STATISTICS = "/api/admin/Event/GetStatistics";
export const API_EVENT_TRASH = "/api/admin/Event/Trash";
export const API_EVENT_UN_TRASH = "/api/admin/Event/UnTrash";

export const API_TRAINING_PROGRAM = "/api/admin/TrainingProgram";
export const API_TRAINING_PROGRAM_SEARCH = "/api/admin/TrainingProgram/Search";
export const API_TRAINING_PROGRAM_STATISTICS =
  "/api/admin/TrainingProgram/GetStatistics";
export const API_TRAINING_PROGRAM_TRASH = "/api/admin/TrainingProgram/Trash";
export const API_TRAINING_PROGRAM_UN_TRASH =
  "/api/admin/TrainingProgram/UnTrash";

export const API_PAGE = "/api/admin/Page";
export const API_PAGE_STATISTICS = "/api/admin/Page/GetStatistics";
export const API_PAGE_TRASH = "/api/admin/Page/Trash";
export const API_PAGE_UN_TRASH = "/api/admin/Page/UnTrash";

export const API_MENU = "/api/admin/Menu";
export const API_MENU_STATISTICS = "/api/admin/Menu/GetStatistics";
export const API_MENU_TRASH = "/api/admin/Menu/Trash";
export const API_MENU_UN_TRASH = "/api/admin/Menu/UnTrash";

export const API_FORM = "/api/admin/Forum";
export const API_FORM_STATISTICS = "/api/admin/Forum/GetStatistics";
export const API_FORM_TRASH = "/api/admin/Forum/Trash";
export const API_FORM_UN_TRASH = "/api/admin/Forum/UnTrash";

export const API_PERMISSION_MODULE = "/api/admin/PermissionModule/GetAll";

export const API_ROLES = "/api/Roles";
export const API_ROLES_PERMISSION = "/api/Roles/UpdateRoleWithPermission";
export const API_PERMISSION_BY_ROLE_ID =
  "/api/admin/Permissions/GetPermissionByRoleId";

export const API_SERVICE_TOOL = "/api/admin/ServiceAndTool";
export const API_SERVICE_TOOL_SEARCH = "/api/admin/ServiceAndTool/Search";
export const API_SERVICE_TOOL_STATISTICS =
  "/api/admin/ServiceAndTool/GetStatistics";
export const API_SERVICE_TOOL_TRASH = "/api/admin/ServiceAndTool/Trash";
export const API_SERVICE_TOOL_UN_TRASH = "/api/admin/ServiceAndTool/UnTrash";

export const API_PUBLIC_ADMINISTRATIONS =
  "/api/admin/Lookup/PublicAdministrations";

export const API_ASSIGN_ROLE_USER = "/api/Roles/AddRolesToUser";

export const API_LANGUAGES = "/api/admin/Language";

export const API_TAGS = "/api/admin/Tag";
export const API_TAGS_SEARCH = "/api/admin/Tag/Search";
export const API_TAGS_STATISTICS = "/api/admin/Tag/GetStatistics";
export const API_TAGS_TRASH = "/api/admin/Tag/Trash";
export const API_TAGS_UN_TRASH = "/api/admin/Tag/UnTrash";

export const API_VISION_MISSION = "/api/admin/MissionVision";

export const API_MAIN_MEASURMENT = "/api/admin/MainValue";
export const API_MAIN_MEASURMENT_SEARCH = "/api/admin/MainValue/Search";
export const API_MAIN_MEASURMENT_TRASH = "/api/admin/MainValue/Trash";
export const API_MAIN_MEASURMENT_UN_TRASH = "/api/admin/MainValue/UnTrash";

export const API_CAPMAS_HEAD = "/api/admin/CapmasHead";
export const API_CAPMAS_HEAD_SEARCH = "/api/admin/CapmasHead/Search";
export const API_CAPMAS_HEAD_TRASH = "/api/admin/CapmasHead/Trash";
export const API_CAPMAS_HEAD_UN_TRASH = "/api/admin/CapmasHead/UnTrash";

export const API_SECTOR = "/api/admin/Sector";
export const API_SECTOR_SEARCH = "/api/admin/Sector/Search";
export const API_SECTOR_TRASH = "/api/admin/Sector/Trash";
export const API_SECTOR_UN_TRASH = "/api/admin/Sector/UnTrash";

export const API_CAPMAS_SECTOR = "/api/admin/CapmasSector";
export const API_CAPMAS_STATISTICS = "/api/admin/CapmasSector/GetStatistics";
export const API_CAPMAS_SECTOR_SEARCH = "/api/admin/CapmasSector/Search";
export const API_CAPMAS_SECTOR_TRASH = "/api/admin/CapmasSector/Trash";
export const API_CAPMAS_SECTOR_UN_TRASH = "/api/admin/CapmasSector/UnTrash";

export const API_CAPMAS_HISTORY = "/api/admin/CapmasHistory";
export const API_CAPMAS_HISTORY_SEARCH = "/api/admin/CapmasHistory/Search";
export const API_CAPMAS_HISTORY_TRASH = "/api/admin/CapmasHistory/trash";
export const API_CAPMAS_HISTORY_UN_TRASH = "/api/admin/CapmasHistory/UnTrask";

export const API_CAPMAS_LAWS = "/api/admin/LawRegulation";
export const API_CAPMAS_LAWS_SEARCH = "/api/admin/LawRegulation/Search";
export const API_CAPMAS_LAWS_TRASH = "/api/admin/LawRegulation/Trash";
export const API_CAPMAS_LAWS_UN_TRASH = "/api/admin/LawRegulation/UnTrash";
export const API_ELEMENT = "/api/admin/Element";
export const API_ELEMENT_BY_KEY = "/api/admin/Element/GetByKey";

export const API_LAWS_REGULATIONS = "/api/admin/LawRegulation";
export const API_ORGANIZATION_CHART = "/api/admin/OrganizationalChart";
export const API_EGYPT_STATISTICS_MAGAZINE =
  "/api/admin/EgyptStatisticsJournal";
export const API_EGYPT_STATISTICS_MAGAZINE_SEARCH =
  "/api/admin/EgyptStatisticsJournal/Search";
export const API_EGYPT_STATISTICS_MAGAZINE_DESCRIPTION =
  "api/admin/EgyptStatisticsJournalDescription";
export const API_WEBSITE_TYPE = "api/admin/WebsiteType";
export const API_WEBSITE_TYPE_TRASH = "/api/admin/WebsiteType/Trash";
export const API_WEBSITE_TYPE_UN_TRASH = "/api/admin/WebsiteType/UnTrash";
export const API_WEBSITE_TYPE_SEARCH = "api/admin/WebsiteType/Search";
export const API_WEBSITE_TYPE_STATISTICS =
  "api/admin/WebsiteType/GetStatistics";

export const API_RELATED_WEBSITE = "api/admin/RelatedWebsite";
export const API_RELATED_WEBSITE_TRASH = "/api/admin/RelatedWebsite/Trash";
export const API_RELATED_WEBSITE_UN_TRASH = "/api/admin/RelatedWebsite/UnTrash";
export const API_RELATED_WEBSITE_SEARCH = "api/admin/RelatedWebsite/Search";
export const API_RELATED_WEBSITE_STATISTICS =
  "api/admin/RelatedWebsite/GetStatistics";
export const API_NEWS_BAR = "api/admin/NewsBar";
export const API_NEWS_BAR_SEARCH = "api/admin/NewsBar/Search";
export const API_NEWS_BAR_TRASH = "api/admin/NewsBar/Trash";
export const API_NEWS_BAR_UN_TRASH = "api/admin/NewsBar/UnTrash";
export const API_NEWS_BAR_STATISTICS = "api/admin/NewsBar/GetStatistics";

export const API_SLIDER_STATISTICS = "api/admin/Slider/GetStatistics";
export const API_SLIDER_SEARCH = "api/admin/Slider/Search";
export const API_SLIDER = "api/admin/Slider";
export const API_SLIDER_TRASH = "api/admin/Slider/Trash";
export const API_SLIDER_UN_TRASH = "api/admin/Slider/UnTrash";

export const API_MAIN_SUBJECT = "api/admin/Subject";
export const API_MAIN_SUBJECT_SEARCH = "api/admin/Subject/Search";
export const API_MAIN_SUBJECT_TRASH = "api/admin/Subject/Trash";
export const API_MAIN_SUBJECT_UN_TRASH = "api/admin/Subject/UnTrash";
export const API_CALENDAR = "api/admin/Calendar";
export const API_INTERNATIONAL_DAY = "api/admin/InternationalDay";
export const API_INTERNATIONAL_DAY_SEARCH = "api/admin/InternationalDay/Search";
export const API_INTERNATIONAL_DAY_TRASH = "api/admin/InternationalDay/Trash";
export const API_INTERNATIONAL_DAY_UN_TRASH =
  "api/admin/InternationalDay/UnTrash";
export const API_INTERNATIONAL_DAY_STATISTICS =
  "api/admin/InternationalDay/GetStatistics";

export const API_PUBLICATION = "api/admin/Publication";
export const API_PUBLICATION_SEARCH = "api/admin/Publication/Search";
export const API_PUBLICATION_TRASH = "api/admin/Publication/Trash";
export const API_PUBLICATION_UN_TRASH = "api/admin/Publication/UnTrash";
export const API_PUBLICATION_STATISTICS = "api/admin/Publication/GetStatistics";
export const API_PUBLICATION_DETAILS_STATISTICS =
  "api/admin/PublicationDetail/GetStatistics";
export const API_PUBLICATION_DETAILS_FILES =
  "api/admin/PublicationDetail/Files?PublicationDetailsId=";
export const API_PUBLICATION_DETAILS_FILES_DELETE =
  "api/admin/PublicationDetail/Files";
export const API_PUBLICATION_DETAILS_FILES_UPLOAD =
  "api/admin/PublicationDetail/UploadFiles";

export const API_PUBLICATION_INFOGRAPHIC = "api/admin/infographic/Publication/";
export const API_PUBLICATION_DETAIL_INFOGRAPHIC =
  "api/admin/infographic/PublicationDetail/";
export const API_PUBLICATION_INFOGRAPHIC_OPERATIONS = "api/admin/Infographic";

export const API_PUBLICATION_DATA = "api/admin/Publication/PublicationData";
export const API_PUBLICATION_DATA_EXPORT =
  "api/admin/Publication/Export/PublicationData";
export const API_GET_PUBLICATION_INDICATOR_BY_ID =
  "api/admin/PublicationIndicator/GetById?id=";
export const API_PUBLICATION_UPDATE =
  "api/admin/PublicationIndicator/UpdatePublicationData";

export const API_PUBLICATION_INDICATORS_LIST_BY_ID =
  "api/admin/PublicationIndicator/GetByPublicationId";
export const API_MERGE_PUBLICATION_INDICATORS =
  "api/admin/PublicationIndicator/MergePublicationIndicator";

export const API_PUBLICATION_TYPE = "api/admin/PublicationType";
export const API_PUBLICATION_TYPE_SEARCH = "api/admin/PublicationType/Search";
export const API_PUBLICATION_TYPE_TRASH = "api/admin/PublicationType/Trash";
export const API_PUBLICATION_TYPE_UN_TRASH =
  "api/admin/PublicationType/UnTrash";
export const API_PUBLICATION_TYPE_STATISTICS =
  "api/admin/PublicationType/GetStatistics";

export const API_PUBLICATION_INDICATOR_DOWNLOAD_TEMPLATE_BASE =
  "api/admin/PublicationIndicator/DownloadTemplate";

/** @param {"xlsx"|"csv"} format */
export function apiPublicationIndicatorDownloadTemplate(format = "xlsx") {
  const normalized = format === "csv" ? "csv" : "xlsx";
  return `${API_PUBLICATION_INDICATOR_DOWNLOAD_TEMPLATE_BASE}/${normalized}`;
}

/** @deprecated Use apiPublicationIndicatorDownloadTemplate("xlsx") */
export const API_PUBLICATION_TRANSLATIONS_DOWNLOAD_TEMPLATE =
  apiPublicationIndicatorDownloadTemplate("xlsx");
export const API_PUBLICATION_TRANSLATIONS_UPLOAD_TEMPLATE = "api/admin/PublicationIndicator/UploadTemplate";

export const API_LK_PUBLICATIONB_TYPE = "api/admin/Lookup/PublicationTypes";
export const API_LK_PERIODIC = "api/admin/Lookup/Periodics";
export const API_LK_PUBLIC_ADMINSTRATION =
  "api/admin/Lookup/PublicAdministrations";
export const API_LK_SUB_SUBJECTS = "api/admin/Lookup/SubSubjects";
export const API_YEAR_TYPE = "api/admin/YearType";

export const API_LK_CENTRAL_ADMINSTRATION =
  "api/admin/Lookup/CentralAdministrations";
export const API_LK_CAPMAS_SECTOR = "/api/admin/CapmasSector";
export const API_LK_PUBLICATIONS = "/api/admin/Lookup/Publications";
export const API_LK_PUBLICATIONS_INDICATORS =
  "/api/admin/Lookup/PublicationIndicators";
export const API_LK_PUBLICATIONS_INDICATORS_FILTERS =
  "/api/admin/Lookup/PublicationIndicatorFilters";

export const API_PUBLICATIONS_INDICATORS = "/api/admin/PublicationIndicator";

export const API_LK_INDICATORS = "/api/admin/Lookup/Indicators";
export const API_LK_INDICATORS_PER_SBUBJECT = "/api/admin/Indicator/Ordering";
export const API_LK_SUBJECTS = "/api/Subject";

export const API_LK_SUBINDICATORS = "/api/admin/Lookup/SubIndicators";

export const API_DEPARTMENT = "api/admin/Department";
export const API_DEPARTMENT_SEARCH = "api/admin/Department/Search";
export const API_DEPARTMENT_TRASH = "api/admin/Department/Trash";
export const API_DEPARTMENT_UN_TRASH = "api/admin/Department/UnTrash";
export const API_DEPARTMENT_STATISTICS = "api/admin/Department/GetStatistics";
export const API_DEPARTMENT_PUBLISH = "api/admin/Department/Publish";
export const API_DEPARTMENT_UN_PUBLISH = "api/admin/Department/UnPublish";

export const API_GET_USER_PUBLICATION =
  "api/admin/Publication/GetUserPublications";

export const API_GET_USER_PUBLICATION_LOOKUP =
  "api/admin/Lookup/UserPublications";

export const API_GET_USER_PUBLICATION_DETAILS =
  "api/admin/Lookup/UserPublicationsWithDetails";

export const API_GET_STUDY_PERIODS = "api/admin/StudyPeriod";

export const API_EvidenceAndClassification =
  "api/admin/EvidenceAndClassification";
export const API_EvidenceAndClassification_SEARCH =
  "api/admin/EvidenceAndClassification/Search";
export const API_EvidenceAndClassification_TRASH =
  "api/admin/EvidenceAndClassification/Trash";
export const API_EvidenceAndClassification_UN_TRASH =
  "api/admin/EvidenceAndClassification/UnTrash";
export const API_EvidenceAndClassification_STATISTICS =
  "api/admin/EvidenceAndClassification/GetStatistics";

export const API_EGYPT_POPULATION = "api/admin/EgyptPopulation";
export const API_EGYPT_POPULATION_SEARCH = "api/admin/EgyptPopulation/Search";

export const API_GOVERNORATE = "/api/admin/Governorate";
export const API_GOVERNORATE_SEARCH = "/api/admin/Governorate/Search";

export const API_GOVERNORATE_POPULATION = "api/admin/GovernoratePopulation";
export const API_GOVERNORATE_POPULATION_SEARCH =
  "api/admin/GovernoratePopulation/Search";

export const API_PUBLICATION_VERSION_MIGRATE = "api/admin/Migration";
export const API_PUBLICATION_VERSION_SEARCH =
  "api/admin/PublicationDetail/Search";
export const API_PUBLICATION_VERSION = "api/admin/PublicationDetail";
export const API_PUBLICATION_VERSION_TRASH =
  "api/admin/PublicationDetail/Trash";
export const API_PUBLICATION_VERSION_UN_TRASH =
  "api/admin/PublicationDetail/UnTrash";
export const API_PUBLICATION_VERSION_STATISTICS =
  "api/admin/PublicationDetail/GetStatistics";

export const API_GATES = "api/admin/ImportantPortal";
export const API_GATES_SEARCH = "api/admin/ImportantPortal/Search";
export const API_GATES_TRASH = "api/admin/ImportantPortal/Trash";
export const API_GATES_UN_TRASH = "api/admin/ImportantPortal/UnTrash";
export const API_GATES_STATISTICS = "api/admin/ImportantPortal/GetStatistics";

export const API_CENSUSES = "api/admin/SurveyCensuse";
export const API_CENSUSES_SEARCH = "api/admin/SurveyCensuse/Search";
export const API_CENSUSES_TRASH = "api/admin/SurveyCensuse/Trash";
export const API_CENSUSES_UN_TRASH = "api/admin/SurveyCensuse/UnTrash";
export const API_CENSUSES_STATISTICS = "api/admin/SurveyCensuse/GetStatistics";

export const API_MICROFILM = "api/admin/MicroFilmData";
export const API_MICROFILM_STATISTICS = "api/admin/MicroFilmData/GetStatistics";

export const API_DATAREQUEST = "api/admin/DataRequest";
export const API_DATAREQUEST_STATISTICS = "api/admin/DataRequest/GetStatistics";

export const API_SELECTED_PAGES_SEARCH = "api/admin/SiteSelection/Search";
export const API_SELECTED_PAGES_STATISTICS =
  "api/admin/SiteSelection/GetStatistics";
export const API_SELECTED_PAGES_TOOL = "api/admin/SiteSelection";
export const API_SELECTED_PAGES_TOOL_TRASH = "api/admin/SiteSelection/Trash";
export const API_SELECTED_PAGES_TOOL_UN_TRASH =
  "api/admin/SiteSelection/UnTrash";

export const API_CONTACT_US_FOOTER = "api/admin/ContactUs";

export const API_PUBLICATION_NEWS = "api/admin/PublicationNews";
export const API_PUBLICATION_NEWS_SEARCH = "api/admin/PublicationNews/Search";
export const API_PUBLICATION_NEWS_STATISTICS =
  "api/admin/PublicationNews/GetStatistics";
export const API_PUBLICATION_NEWS_TRASH = "api/admin/PublicationNews/Trash";
export const API_PUBLICATION_NEWS_UN_TRASH =
  "api/admin/PublicationNews/UnTrash";

export const API_DASHBOARD_STATISTICS = "api/admin/Dashboard/GetStatistics";
export const API_PUBLICATION_DETAILS_LINE_GRAPH =
  "api/admin/Dashboard/PublicationWithDetailsLineGraph";
export const API_SUBJECT_INDICATORS_LINE_GRAPH =
  "api/admin/Dashboard/SubjectIndicatorsLineGraph";
export const API_SUBJECT_PUBLICATION_LINE_GRAPH =
  "api/admin/Dashboard/SubjectPublicationLineGraph";
export const API_APP_SETTINGS = "/api/admin/AppSetting";

export const API_MAIN_INDICATORS_STATISTICS =
  "/api/admin/Indicator/GetStatistics";
export const API_MAIN_INDICATORS = "/api/admin/Indicator";
export const API_MAIN_INDICATORS_SEARCH = "/api/admin/Indicator/Search";
export const API_MAIN_INDICATORS_TRASH = "/api/admin/Indicator/Trash";
export const API_MAIN_INDICATORS_UN_TRASH = "/api/admin/Indicator/UnTrash";

export const API_SUB_INDICATORS_STATISTICS = "/api/admin/Filter/GetStatistics";
export const API_SUB_INDICATORS = "/api/admin/Filter";
export const API_SUB_INDICATORS_SEARCH = "/api/admin/Filter/Search";
export const API_SUB_INDICATORS_TRASH = "/api/admin/Filter/Trash";
export const API_SUB_INDICATORS_UN_TRASH = "/api/admin/Filter/UnTrash";

export const API_SOCIAL_LINK = "api/admin/SocialLink";

export const API_MEASUREUNIT = "api/admin/MeasureUnit";

export const API_HAPPENING_NOW_STATISTICS =
  "/api/admin/HappeningNow/GetStatistics";
export const API_HAPPENING_NOW = "/api/admin/HappeningNow";
export const API_HAPPENING_NOW_SEARCH = "/api/admin/HappeningNow/Search";
export const API_HAPPENING_NOW_TRASH = "/api/admin/HappeningNow/Trash";
export const API_HAPPENING_NOW_UN_TRASH = "/api/admin/HappeningNow/UnTrash";

export const API_INDICATORS_STATISTICS = "/api/admin/Filter/GetStatistics";
export const API_INDICATORS = "/api/admin/Filter";
export const API_INDICATORS_SEARCH = "/api/admin/Filter/Search";
export const API_INDICATORS_TRASH = "/api/admin/Filter/Trash";
export const API_INDICATORS_UN_TRASH = "/api/admin/Filter/UnTrash";

export const API_SURVEY = "api/admin/Survey";
export const API_SURVEY_SEARCH = "api/admin/Survey/Search";
export const API_SURVEY_STATISTICS = "api/admin/Survey/GetStatistics";
export const API_SURVEY_RESULTS = "api/admin/Survey/Result?id=";
export const API_SURVEY_SUGGESTIONS = "api/admin/Survey/Comments?id=";
export const API_SURVEY_TRASH = "/api/admin/Survey/Trash";
export const API_SURVEY_UN_TRASH = "/api/admin/Survey/UnTrash";

export const API_SELECTED_INDICATOR_DETAILS =
  "/api/admin/SelectedIndicator/SelectedIndicatorDetails";
export const API_SELECTED_INDICATOR = "/api/admin/SelectedIndicator";
export const API_SELECTED_INDICATOR_SEARCH =
  "/api/admin/SelectedIndicator/Search";
export const API_SELECTED_INDICATOR_STATISTICS =
  "/api/admin/SelectedIndicator/GetStatistics";
export const API_SELECTED_INDICATOR_TRASH =
  "/api/admin/SelectedIndicator/Trash";
export const API_SELECTED_INDICATOR_UN_TRASH =
  "/api/admin/SelectedIndicator/UnTrash";

export const API_PIN_INDICATOR = "api/admin/PinedIndicator";
export const API_PIN_INDICATOR_ADD = "api/admin/PinedIndicator/Add";

export const API_PUBLICATION_SUBSCRIPTION =
  "/api/admin/PublicationSubscription";
export const API_PUBLICATION_SUBSCRIPTION_SEARCH =
  "/api/admin/PublicationSubscription/Search";
export const API_PUBLICATION_SUBSCRIPTION_TRASH =
  "/api/admin/PublicationSubscription/Trash";
export const API_PUBLICATION_SUBSCRIPTION_UN_TRASH =
  "/api/admin/PublicationSubscription/UnTrash";

export const API_NATIONAL_CENTER = "/api/admin/TrainingRequest";

export const API_FORGET_PASS = "/api/Auth/ForgotPassword";
export const API_RESET_CODE = "/api/Auth/ResetCode";
export const API_RESET_PASS = "/api/Auth/ExecuteForgotPassword";
export const API_RESET_PASS_PROFILE = "/api/Auth/ResetPassword";

export const API_MEASURE_UNITS = "/api/admin/MeasureUnit";

export const API_REFRESH_TOKEN = "api/Auth/RefreshToken"
export const API_LOGOUT = "api/Auth/Logout"


export const API_FREQUENTLY_QUESTIONS = "/api/admin/frequently/questions";
export const API_AVERAGE_TOTAL_USAGE = "/api/admin/analytics/average-total-usage";
export const API_AVERAGE_USAGE_PER_USER = "/api/admin/analytics/average-usage-per-user";
export const API_AVERAGE_RESPONSE_TIME = "/api/admin/analytics/average-response-time";
export const API_USERS_COUNT = "/api/admin/users/count";
export const API_QUESTIONS_COUNT = "/api/admin/questions/count";
export const API_CONVERSATIONS_COUNT = "/api/admin/conversations/count";
export const API_MAIN_TOPICS = "/api/main_topics";
export const API_TARGET_BULLETINS = "/api/target_bulletins";
export const API_FEEDBACK_MESSAGES_LIKE = "/api/feedback/messages/like";
export const API_FEEDBACK_MESSAGES_DISLIKE = "/api/feedback/messages/dislike";


export const API_DATA_QUALITY_CHARTS = "/api/admin/DataQuality/ChartData";
export const API_DATA_QUALITY_DETECT_ANOMALIES = "/api/admin/DataQuality/DetectAnomalies";
export const API_DATA_QUALITY_DETECT_ANOMALIES_UPDATE = "/api/admin/DataQuality/UpdateValue";

export const API_NOTIFICATION_UNREAD_NOTIFICATIONS_COUNT = "/api/admin/Notification/UnreadNotificationsCount";
export const API_NOTIFICATIONS = "/api/admin/Notification";
export const API_NOTIFICATIONS_MARK_AS_READ = "/api/admin/Notification/NotificationRead";

/** Culture/locale for API headers (`locale`, `Accept-Language`). Theme keys: `ar` / `en`. */
export const getApiRequestLocale = (themeLocale) => {
  const loc = String(themeLocale || "en").toLowerCase();
  return loc === "ar" || loc.startsWith("ar") ? "ar-EG" : "en";
};

/** @deprecated Use getApiRequestLocale */
export const getDataQualityChartRequestCulture = getApiRequestLocale;